export const volumeLow = {
	className: 'icon-volume-low',
	viewBox: '0 0 288 351.08499',
	paths: ['m 0,111.542 0,128 85.334,0 L 192,351.085 192,0 85.334,111.542 0,111.542 Z m 288,64 c 0,-38.399 -21.333,-72.407 -53.333,-88.863 l 0,176.636 C 266.667,247.95 288,213.942 288,175.542 Z']
}
